import React, { useState, useEffect } from 'react';

import {
  loginAction,
  getLoginUrl,
} from '../../../../../../../../public-src/core/js/schibsted-account/index.server.js';
import { LinkWithPulse } from '../../../../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';

const LoginButton: React.FC = () => {
  const [href, setHref] = useState<string>('');

  useEffect(() => {
    // For preventing server/client mismatch
    setHref(getLoginUrl());
  }, []);

  return (
    <LinkWithPulse
      className="link login"
      href={href}
      objectId="navigation:login-poll-button"
      name="Login-poll-button navigation poll"
      onResolveAction={() =>
        loginAction({ state: `vink-${window.location.href}` })
      }
      preventDefaultAction={true}
    >
      Logg inn for å delta
    </LinkWithPulse>
  );
};

export { LoginButton };
